import { useMemo } from 'react';
import { useEventComposerGlobalContext } from '../composers/EventComposerGlobalContext';
import { approvedRequestFieldsLocked } from '../utils/approvedRequestFieldsLocked';
export function useApprovedRequestFieldsLocked(requestOnlySpace, approved) {
    var _a = useEventComposerGlobalContext(), composerMode = _a.composerMode, canApprove = _a.canApprove, approvalPermissionLoading = _a.approvalPermissionLoading;
    return useMemo(function () {
        return approvedRequestFieldsLocked({
            isRequestOnlySpace: !!requestOnlySpace,
            composerMode: composerMode,
            approved: approved,
            canApprove: canApprove,
            approvalPermissionLoading: approvalPermissionLoading,
        });
    }, [
        requestOnlySpace,
        composerMode,
        approved,
        canApprove,
        approvalPermissionLoading,
    ]);
}
